<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="9">
                <rkm-form-input
                    :validations="validations.nome"
                    label="Nome"
                    uppercase
                    v-model="model.nome"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    :options="form.tipos"
                    label="Tipo"
                    show-default-option
                    text-field="nome"
                    v-model="model.tipoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {
            return {
                nome: {
                    required: true,
                    min: 3,
                    max: 100,
                },
            }
        },
    },
    created() {
        this.repositories = {
            servico: this.getConectaSusRepository('ambulatorio.servico'),
        }
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {
                this.repositories.servico.edit(this.id)
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.repositories.servico.create()
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {
                        nome: this.model.nome,
                        tipoId: this.model.tipoId,
                    }

                    if (this.id) {
                        this.repositories.servico.update(this.id, this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('saved', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    } else {
                        this.repositories.servico.store(this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('saved', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
    },
    mixins: [error, repository, stringCase],
    mounted() {
        this.load()
    },
    props: {
        id: { type: Number },
    },
}
</script>